if (!customElements.get('comparison-table')) {
    customElements.define('comparison-table', class comparisonTable extends HTMLElement {
        constructor() {
            super();
            this.related_products = this.getAttribute('related-products').split(',');
            this.section_id = this.getAttribute('section-id');
            this.desktop_container = this.querySelector('.plug-product-comparison__table');
            this.mobile_container = this.querySelector('.plug-product-comparison__slider');
            this.mobile_container_slider = this.mobile_container.querySelector('[plug-slider]')
            console.log(this.related_products);
            
            this.initProducts();
            this.initAccessibility();
        }

        initAccessibility() {
          this.desktop = document.querySelector('[desktop-accessibility]');
          this.mobile = document.querySelector('[mobile-accessibility]');
          if (window.innerWidth < 1000) {
            this.desktop_status = true;
            this.mobile_status = false;
          } else {
            this.desktop_status = false;
            this.mobile_status = true;
          }
          this.desktop.setAttribute('aria-hidden', this.desktop_status);
          this.mobile.setAttribute('aria-hidden', this.mobile_status)
          window.addEventListener("resize", (event) => {
            if (window.innerWidth < 1000) {
              this.desktop_status = true;
              this.mobile_status = false;
            } else {
              this.desktop_status = false;
              this.mobile_status = true;
            }
            this.desktop.setAttribute('aria-hidden', this.desktop_status);
            this.mobile.setAttribute('aria-hidden', this.mobile_status)
          });
        }

        setAccessibility() {
          this.desktop.forEach((element) => {
            element.setAttribute('aria-hidden', this.desktop_status);
          })
          this.mobile.forEach((element) => {
            element.setAttribute('aria-hidden', this.mobile_status);
          })
        }
        initProducts() {
            let _this = this;
          if (this.related_products != undefined && this.related_products.length > 0) {
            this.related_products.forEach((product) => {
                let request_header = {
                    credentials: 'same-origin',
                    method: 'GET'
                }
                let url = '/products/' + product  + '?section_id=' + _this.section_id;
              console.log(url)
                fetch(url, request_header)
                .then((response) => { return response.text()})
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  let comparison_table = html.querySelector('comparison-table');
                  let desktop = comparison_table.querySelector('.plug-product-comparison__table');
                  let desktop_rows = desktop.querySelectorAll('tr');

                  html.querySelectorAll('.plug-product-comparison__current').forEach((elem) => {elem.remove();});
                  html.querySelectorAll('.plug-product-comparison__button').forEach((elem) => {elem.classList.remove('hidden')});
                  html.querySelectorAll('.plug-product-comparison__button').forEach((elem) => {elem.removeAttribute('aria-hidden')});
                  html.querySelectorAll('.plug-product-comparison__button').forEach((elem) => {elem.removeAttribute('tabindex')});
                    
                  desktop_rows.forEach( (row) => {
                    let item = row.getAttribute('data-item');
                    this.desktop_container.querySelector(`[data-item="${item}"]`).append(row.querySelector('td'));
                  });

  
                  var flkty = new Flickity(this.mobile_container_slider);
                  let mobile_slides =  html.querySelectorAll('.plug-product-comparison__slide');
                  mobile_slides.forEach((slide) => {
                    flkty.append(slide)
                  });
                  flkty.resize();
                  this.mobile_container.style.opacity =  1;
                }).catch(e => {
                  console.error(e);
                });
            });
          }
        }
    })
}